import { useEffect, useRef } from 'react';
import './Hero.css';

const roles = ['Frontend Developer', 'React Specialist', 'UI Builder', 'API Integrator'];

export default function Hero() {
  const roleRef = useRef(null);
  const idx = useRef(0);
  const charIdx = useRef(0);
  const deleting = useRef(false);

  useEffect(() => {
    let timer;
    const type = () => {
      const role = roles[idx.current];
      if (!deleting.current) {
        charIdx.current++;
        if (roleRef.current) roleRef.current.textContent = role.slice(0, charIdx.current);
        if (charIdx.current === role.length) {
          deleting.current = true;
          timer = setTimeout(type, 1800);
          return;
        }
      } else {
        charIdx.current--;
        if (roleRef.current) roleRef.current.textContent = role.slice(0, charIdx.current);
        if (charIdx.current === 0) {
          deleting.current = false;
          idx.current = (idx.current + 1) % roles.length;
        }
      }
      timer = setTimeout(type, deleting.current ? 60 : 100);
    };
    timer = setTimeout(type, 600);
    return () => clearTimeout(timer);
  }, []);

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section className="hero" id="hero">
      <div className="hero-bg">
        <div className="hero-orb orb-1" />
        <div className="hero-orb orb-2" />
        <div className="hero-grid" />
      </div>

      <div className="container hero-content">
        <div className="hero-badge">
          <span className="badge-dot" />
          Available for opportunities
        </div>

        <h1 className="hero-title">
          Hi, I'm <span className="hero-name">Sumima</span>
          <br />
          <span className="hero-name-full">Shakya</span>
        </h1>

        <div className="hero-role">
          <span className="role-text" ref={roleRef} />
          <span className="cursor">|</span>
        </div>

        <p className="hero-desc">
          Frontend developer crafting clean, scalable UIs with React & modern tooling.
          1+ year of experience building user-friendly web experiences from Lalitpur, Nepal.
        </p>

        <div className="hero-actions">
          <button className="btn-primary" onClick={() => scrollTo('projects')}>
            View My Work
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M7 17L17 7M17 7H7M17 7v10"/>
            </svg>
          </button>
          <button className="btn-secondary" onClick={() => scrollTo('contact')}>
            Get in Touch
          </button>
        </div>

        <div className="hero-stats">
          <div className="stat">
            <span className="stat-num">1+</span>
            <span className="stat-label">Year Experience</span>
          </div>
          <div className="stat-divider" />
          <div className="stat">
            <span className="stat-num">4+</span>
            <span className="stat-label">Projects Built</span>
          </div>
          <div className="stat-divider" />
          <div className="stat">
            <span className="stat-num">10+</span>
            <span className="stat-label">Technologies</span>
          </div>
        </div>
      </div>

      <div className="scroll-hint" onClick={() => scrollTo('about')}>
        <div className="scroll-wheel" />
        <span>Scroll down</span>
      </div>
    </section>
  );
}
